<template lang="html">

    <div class="contenedor-popup-cups row-center">
        <div class="info-pop column-center">
            <a class="cerrar">✕</a>
            <p>¡Vaya! ha ocurrido un error, pero vamos a trabajar en ello para arreglarlo lo antes posible.</p>
            <div class="dudas">
                <p>Si nos necesitas, puedes llamarnos <a href="tel:900848402">900 848 402</a></p>
            </div>
        </div>
    </div>

</template>

<script lang="js">
    export default {
      name: 'popup-error',
    }
  </script>

<style scoped lang="scss">
    @import '@/assets/css/colors.scss';
  
    .contenedor-popup-cups {
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      z-index: 10;
      background: rgba(0, 0, 0, .4);
    }
  
    .info-pop {
      position: relative;
      background: $dark;
      max-width: 450px;
      width: 100%;
      color: white;
      padding: 25px;
      z-index: 10;
      border-radius: 5px;
  
      .cerrar {
        position: absolute;
        right: 10px;
        top: 10px;
      }
  
      >p {
        color: white;
        max-width: 100%;
        font-size: 14px;
        font-weight: 400;
  
        strong {
          font-weight: bold;
          width: 100%;
          font-size: 16px;
          display: inline-block;
        }
      }
  
      .dudas {
        width: 100%;
        margin-top: 10px;
  
        p {
          color: white;
          font-size: 14px;
          width: 100%;
          font-weight: 400;
          margin-bottom: 0;
  
          a {
            text-decoration: underline;
          }
        }
      }
  
      img {
        max-width: 100%;
        width: 100%;
      }
    }
  </style>


// WEBPACK FOOTER //
// src/components/parts/popup-error.vue